import gql from "graphql-tag";

const SEARCH = gql`
  query Search(
    $query: String!
    $page: Int
    $limit: Int
    $queryType: QueryType
    $feedPreference: FeedPreference
    $searchType: SearchType
  ) {
    search(
      query: $query
      limit: $limit
      page: $page
      queryType: $queryType
      feedPreference: $feedPreference
      searchType: $searchType
    ) {
      plays {
        id
        gamePk
        description
        gameDate
        videos {
          feedType
          link
          rank
          image {
            cuts {
              at2x
            }
          }
        }
        fields {
          name
          value
          displayValue
        }
        links {
          href
          rel
        }
      }
      total
    }
  }
`;

const FIELDS = gql`
  query Fields($ids: [Int], $searchType: SearchType) {
    fields(ids: $ids, searchType: $searchType) {
      id
      category
      description
      defaultOperator
      displayName
      display
      helperText
      name
      type
      entityType
      supportsDistinctValues
      typeAheadEnabled
      values {
        value
        displayValue
      }
    }
  }
`;

export const FIELDS_WITHOUT_VALUES_CLAUSE = gql`
  query Fields($ids: [Int], $searchType: SearchType) {
    fields(ids: $ids, searchType: $searchType) {
      id
      category
      description
      defaultOperator
      displayName
      display
      helperText
      name
      type
      entityType
      supportsDistinctValues
      typeAheadEnabled
    }
  }
`;

const COMMON_FIELDS = gql`
  query CommonFields($plays: [String]!) {
    commonFields(plays: $plays) {
      name
      value
    }
  }
`;

const TYPES = gql`
  query Types {
    types {
      name
      supportedComparators {
        name
        displayName
        symbol
      }
    }
  }
`;

const QUERY_INFO = gql`
  query QueryInfo($queries: [String]!, $queryType: QueryType) {
    queryInfo(queries: $queries, queryType: $queryType) {
      query
      valid
      graph
    }
  }
`;

export { SEARCH, FIELDS, COMMON_FIELDS, TYPES, QUERY_INFO };



// WEBPACK FOOTER //
// ./src/httpClients/graphql/pits-queries.js